import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Diaper = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M25 4H7C5.35 4 4 5.35 4 7V19C4 23.962 8.037 28 13 28H19C23.962 28 28 23.962 28 19V7C28 5.35 26.65 4 25 4ZM26 14H23C22.45 14 22 13.55 22 13C22 12.45 22.45 12 23 12H26V14ZM7 6H8V7C8 7.55 8.45 8 9 8C9.55 8 10 7.55 10 7V6H12V7C12 7.55 12.45 8 13 8C13.55 8 14 7.55 14 7V6H18V7C18 7.55 18.45 8 19 8C19.55 8 20 7.55 20 7V6H22V7C22 7.55 22.45 8 23 8C23.55 8 24 7.55 24 7V6H25C25.55 6 26 6.45 26 7V10H23C21.35 10 20 11.35 20 13C20 14.65 21.35 16 23 16H26V18.063C21.837 18.525 18.525 21.838 18.062 26.001H13.949C13.486 21.838 10.174 18.526 6.011 18.063V16H9.011C10.661 16 12.011 14.65 12.011 13C12.011 11.35 10.648 10 8.999 10H5.999V7C5.999 6.45 6.449 6 6.999 6H7ZM6 12H9C9.55 12 10 12.45 10 13C10 13.55 9.55 14 9 14H6V12ZM6.088 20.087C9.075 20.549 11.45 22.924 11.926 25.924C8.926 25.449 6.551 23.074 6.088 20.087ZM20.087 25.913C20.549 22.925 22.924 20.55 25.924 20.076C25.449 23.076 23.074 25.451 20.087 25.913Z" />
	</svg>
);

export default Diaper;
